<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  :pageData="pageData"></table-page>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    //接口地址url的统一管理
    import URL from '@/views/trade/util/url'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    let orderTypeList = {0:"待开奖",1:"中奖",2:"中奖",3:"未中奖",4:"已作废"};
    let tradeTypeList = {0:"看跌",1:"看涨"};
    export default {
        name: 'realOrderRecord',
        components: {
            tablePage,
            FORM,
        },
        methods: {
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName){
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                }
            },
        },
        data () {
            return {
                queryData:{},
                /*from查询表单*/
                formData:{
                  //hasLable: true,
                  cols:[
                      {click:"查询"},
                      ]
                },
                /*table生成*/
              pageData: {
                isShow: false,
                queryUrl: URL.realOrder.realOrderQuery, //请求路径和参数
                selection: false,
                sequence: true,
                method: 'post-json',
                cols: [
                  { title: "订单号", field: 'orderId'},
                  { title: "交易账号", field: 'customerNumber'},
                  { title: "交易产品", field: 'productCode'},
                  { title: "下单金额", field: 'amount'},
                  { title: "下单价格", field: 'orderPrice'},
                  { title: "交易方向", field: 'tradeDirection',render:(data,full)=>{
                      return tradeTypeList[data];
                    }},
                  { title: "订单状态", field: 'orderStatus',render:(data,full)=>{
                      return orderTypeList[data];
                    }},
                  { title: "下单时间", field: 'orderTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                    }},
                  { title: "开奖时间", field: 'lotteryTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                    }},
                  { title: "开奖价格", field: 'lotteryPrice'},
                  { title: "订单收益", field: 'orderProfit'},
                ]
              }
            }
        }
    }
</script>

